export type IntervalUpdateCallback = () => void

export class IntervalUpdater {
  protected interval: number
  protected cb: IntervalUpdateCallback
  protected isIdle = true

  constructor (cb: IntervalUpdateCallback, interval = 10 * 60 * 1000) {
    this.cb = cb
    this.interval = interval
  }

  touch () {
    if (this.isIdle) {
      this.isIdle = false
      const timer = setTimeout(() => {
        this.isIdle = true
        clearTimeout(timer)
        this.cb()
      }, this.interval)
    }
  }
}
